import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    refresh_token: null,
    access_token: null,
    userFavorites: []
  },
  mutations: {
    loadUserState (state) {
      if (localStorage.getItem('refresh_token')) state.refresh_token = JSON.parse(localStorage.getItem('refresh_token'))
      if (localStorage.getItem('user')) state.user = JSON.parse(localStorage.getItem('user'))
      if (localStorage.getItem('@elvas:favorites')) state.userFavorites = JSON.parse(localStorage.getItem('@elvas:favorites'))
    },
    deleteUserState (state) {
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
      state.user = null
      state.refresh_token = null
      state.access_token = null
      state.userFavorites = null
      sessionStorage.removeItem('token')
    },
    loginData (state, data) {
      state.user = data.user
      state.refresh_token = data.refresh_token
      localStorage.setItem('user', JSON.stringify(data.user))
      localStorage.setItem('refresh_token', JSON.stringify(data.refresh_token))
    },
    favoritesData (state, data) {
      const formattedFavorites = data.map(item => ({
        ...item,
        isFavorite: true
      }))
      state.favoritesData = formattedFavorites
      localStorage.setItem('@elvas:favorites', JSON.stringify(formattedFavorites))

    },
    accessTokenData (state, accessToken) {
      state.access_token = accessToken
      sessionStorage.setItem('token', JSON.stringify(accessToken))
    },
    toggleInterestPointFavoriteData(state, {interestPoint, hasToAdd}){
      if(hasToAdd){
        const alreadyInArray = state.userFavorites.find(favorite => favorite.interest_point.id === interestPoint.id)
        if(alreadyInArray){
          const formattedFavorites = state.userFavorites.map(favorite => favorite.interest_point.id === interestPoint.id ? {
            ...favorite,
            isFavorite: true
          }: favorite)
 
          state.userFavorites = formattedFavorites
          localStorage.setItem('@elvas:favorites', JSON.stringify(formattedFavorites))

        } else {
          state.userFavorites.push({
            interest_point: {
              ...interestPoint
            },
            isFavorite: true
          })
          localStorage.setItem('@elvas:favorites', JSON.stringify(state.userFavorites))
        }
 
      } else {
        const formattedFavorites =
         state.userFavorites.map(favorite => favorite.interest_point.id === interestPoint.id ? {
           ...favorite,
           isFavorite: false
         }: favorite)

         state.userFavorites = formattedFavorites
         localStorage.setItem('@elvas:favorites', JSON.stringify(formattedFavorites))
      }
    }
  },
  actions: {
    async loadUserData (context) {
      context.commit('loadUserState')
      if (!context.state.refresh_token || !context.getters.isTokenValid(context.state.refresh_token)) {
        context.commit('deleteUserState')
        return false
      } else {
        try {
          await context.dispatch('generateAccessToken', { refresh_token: context.state.refresh_token.token, user_id: context.state.user.id })
          // update user data TODO
          return true
        } catch (e) {
          return e
        }
      }
    },
    async login (context, data) {
      try {
        const loginData = await this._vm.api.post('/auth/login', data)
        context.commit('loginData', loginData.data)
        await context.dispatch('generateAccessToken', { refresh_token: loginData.data.refresh_token.token, user_id: loginData.data.user.id })
        const favoritesData = await this._vm.api.get('/user/favorite')
        context.commit('favoritesData', favoritesData)
        return loginData
      } catch (e) {
        return e
      }
    },
    async logout (context, data) {
      context.commit('deleteUserState')
    },
    async checkAuth (context) {
      const authCheck = await this._vm.api.post('/auth/checkAccessToken', { access_token: context.state.user.user_id, user_id: context.state.user.id })
      return authCheck
    },
    async register (context, data) {
      try {
        const register = await this._vm.api.post('/auth/register', data)
        return register
      } catch (e) {
        return e
      }
    },
    async generateAccessToken (context, data) {
      const { data: { access_token: accessToken } } = await context.dispatch('repeatOnFail', { tries: 3, method: this._vm.api.post, url: '/auth/generateAccessToken', data })
      context.commit('accessTokenData', accessToken)
      return accessToken
    },
    async repeatOnFail (context, data) {
      for (let i = 0; i < data.tries; i++) {
        try {
          return await data.method(data.url, data.data)
        } catch (e) {
          continue
        }
      }
    },
    retrieveUserInfoFacebook(context, authResponse) {
      let app = this
      return this._vm.api.post('/auth/facebook', authResponse)
      .then(async function (loginData) {
        context.commit('loginData', loginData.data)
        await context.dispatch('generateAccessToken', { refresh_token: loginData.data.refresh_token.token, user_id: loginData.data.user.id })
        return loginData
      })
    },
    retrieveUserInfoGoogle(context, authResponse) {
      let app = this
      return this._vm.api.post('/auth/google', authResponse)
      .then(async function (loginData) {
        context.commit('loginData', loginData.data)
        await context.dispatch('generateAccessToken', { refresh_token: loginData.data.refresh_token.token, user_id: loginData.data.user.id })
        return loginData
      })
    },
    toggleFavoriteInterestPoint(context, {interestPoint, hasToAdd}) {
      return context.commit('toggleInterestPointFavoriteData', {interestPoint, hasToAdd})
    }
  },
  getters: {
    isTokenValid: () => (token) => {
      return new Date(token.expiration_at).getTime() - new Date().getTime() >= 0
    },
    isFavorite: () => (favoritesData, interestPointId) => {
      const interestPoint = favoritesData.find(favorite => favorite.interest_point.id === interestPointId)
      return interestPoint && interestPoint.isFavorite
    }
  },
  modules: {
  }
})